import { render } from "./calendario.vue?vue&type=template&id=4db18a8e&scoped=true"
import script from "./calendario.vue?vue&type=script&lang=js"
export * from "./calendario.vue?vue&type=script&lang=js"

import "./calendario.vue?vue&type=style&index=0&id=4db18a8e&lang=scss&scoped=true"
import "./calendario.vue?vue&type=style&index=1&id=4db18a8e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db18a8e"]])

export default __exports__